import { renderCellGrayZeros } from 'app/common/templates-next/table-template'

type CommonCell = {
  columnKey: string
  value: string | null
}

export const renderTableCell = (cellData?: CommonCell) => {
  return renderCellGrayZeros(cellData)
}
